let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aJlTg")).then(() => parcelRequire('9Lsza'));